window.OSM = window.OSM ?? {};
/**
 * @type {IMapsProps}
 */
OSM.MapConfigs = OSM.MapConfigs ?? {}